export const PERMISSIONS: { [key in string]: string } = {
  transactionsList: "Transactions.TransactionList",
  transactionsListExport: "Transactions.TransactionListExport",
  transactionListPictusExport: "TransactionList.ExportPictusJson",
  transactionDetails: "Transactions.TransactionDetailsPage",
  transactionHistory: "TransactionDetailsPage.SeeHistory",
  transactionHistoryExport: "TransactionDetailsPage.ExportHistory",
  addCorrection: "TransactionDetailsPage.CorrectTransaction",
  submitCorrection: "TransactionDetailsPage.CorrectTransaction",
  transfersList: "WebApp.StorageTransfersMenu",
  transfersListExport: "WebApp.StorageTransfersMenu",
  transfersDetails: "StorageTransfersMenu.TransferDetailsPage",
  transferHistory: "StorageTransfersMenu.TransferDetailsPage",
  transferHistoryExport: "StorageTransfersMenu.TransferDetailsPage",
  transferCancel: "StorageTransfersMenu.TransferDetailsPage",
  editDisposition: "Inventory.CreateDispositionTransaction",
  transactionUpdateTrailerNumber: "TransactionDetailsPage.UpdateTrailerNumber",
  transactionUpdateClaimNumber: "TransactionDetailsPage.UpdateClaimNumber",
  transactionCreateReceipt: "TransactionDetailsPage.CreateReceipt",
  transactionEditTireTypeWeights: "TransactionDetailsPage.EditTireTypeWeights",
  transactionInvalidation: "TransactionDetailsPage.InvalidateTransaction",
  transactionSeeTraceability: "TransactionDetailsPage.SeeTraceability",
  invoiceCreate: "WebApp.CreateInvoice",
  invoicesList: "Invoices.ListOfInvoices",
  invoicesListExport: "ListOfInvoices.ExportListOfInvoices",
  invoiceDetails: "Invoices.InvoiceDetails",
  requestDetails: "PickupRequests.PickupRequestDetails",
};

export const TRANSACTIONS_QUERY_KEY = "transactions";
export const CORRECTIONS_QUERY_KEY = "corrections";
export const TRANSFERS_QUERY_KEY = "transfers";
export const INVOICES_QUERY_KEY = "invoices";
export const TRANSACTION_ACTIVITIES_QUERY_KEY = "transactionActivities";

export const COMMENT_LENGTH_LIMIT = 500;

export const PAGE_SIZE = 20;

export const FLAG_COLOR = "#E64040";
export const WARNING_COLOR = "#F2A033";

export default PERMISSIONS;
